import {
    GESTION_OPERATIVA_SET_SALE_STATE_BEGIN,
    GESTION_OPERATIVA_SET_SALE_STATE_SUCCESS,
    GESTION_OPERATIVA_SET_SALE_STATE_FAILURE,
    GESTION_OPERATIVA_SET_CAN_BE_SAVED,
  } from './constants'
  import { BFFAgent } from '../../../common/BFFAgent'
  import { cloneDeep } from 'lodash'
  import Swal from 'sweetalert2'
import { ErrorAction } from './actions'
  
  export function setState(id, sale, state) {
        let updatedSale = {...sale, sale_state: state}

        return async (dispatch) => {
        // optionally you can have getState as the second argument
        dispatch({
            type: GESTION_OPERATIVA_SET_SALE_STATE_BEGIN,
        })
    
        try {
            const result = await BFFAgent.Sales.updateSale(id, updatedSale);
            dispatch({
            type: GESTION_OPERATIVA_SET_SALE_STATE_SUCCESS,
            data: result,
            })
            Swal.fire('Solicitud anulada', '', 'success')
    
        } catch (err) {
            dispatch({
            type: GESTION_OPERATIVA_SET_SALE_STATE_FAILURE,
            data: { error: err },
            })

            dispatch(
                ErrorAction({
                    title: err.message
                })
            )
        }
        }
    }

    export function setCanBeSaved(saveButtonDisabled) {
        return async (dispatch) => {
            dispatch({
                type: GESTION_OPERATIVA_SET_CAN_BE_SAVED,
                data: { saveButtonDisabled },
            })
        }
    }
    
    export function reducer(state, action) {
        const newState = {
            ...state,
            saveButtonDisabled: true,
        }
        switch (action.type) {
            case GESTION_OPERATIVA_SET_SALE_STATE_BEGIN:
                // Just after a request is sent
                return newState
        
            case GESTION_OPERATIVA_SET_SALE_STATE_SUCCESS:
                // The request is success
                return {
                ...state,
                saveButtonDisabled: true,
                // clonar data
                sale: {
                    ...state.sale,
                    sale_state: cloneDeep(action.data.sale_state),
                    },
                }
        
            case GESTION_OPERATIVA_SET_SALE_STATE_FAILURE:
                // The request is failed
                return newState
            
            case GESTION_OPERATIVA_SET_CAN_BE_SAVED:
                return {
                    ...state,
                    saveButtonDisabled: action.data.saveButtonDisabled,
                }
        
            default:
                return state
        }
    }
